const getters = {
  isWXConfig: state => {
    return state.wechat.isConfig
  },
  isLogin: state => {
    return state.user.isLogin
  },
  appName: state => {
    return state.appInfo.appName
  },
  ak: state => {
    return state.appInfo.ak
  },
  addressHistory: state => {
    return state.wechat.addressHistory
  }
}

export default getters
